import {memo} from 'react';

import type {SVGProps} from 'react';

export const PasswordCheckIllustration = memo(function PasswordCheckIllustration(
  props: SVGProps<SVGSVGElement>
) {
  return (
    <svg
      width={64}
      height={64}
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M54.8468 16H19.8202C16.2375 16 13.3335 18.8427 13.3335 22.3493V36.3173C13.3335 39.824 16.2375 42.6667 19.8202 42.6667H54.8468C58.4295 42.6667 61.3335 39.824 61.3335 36.3173V22.3493C61.3335 18.8427 58.4295 16 54.8468 16Z"
        fill="#9FA8DA"
      />
      <path
        d="M37.0362 10H14.0002C10.3188 10 7.3335 12.9853 7.3335 16.6667V31.3333C7.3335 35.0147 10.3188 38 14.0002 38"
        stroke="#18193F"
        strokeWidth={4}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M44.6665 38H49.9998C53.6812 38 56.6665 35.0147 56.6665 31.3333V16.6667C56.6665 12.9853 53.6812 10 49.9998 10H44.6665"
        stroke="#18193F"
        strokeWidth={4}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.0002 26.6663C21.4729 26.6663 22.6668 25.4724 22.6668 23.9997C22.6668 22.5269 21.4729 21.333 20.0002 21.333C18.5274 21.333 17.3335 22.5269 17.3335 23.9997C17.3335 25.4724 18.5274 26.6663 20.0002 26.6663Z"
        fill="#18193F"
      />
      <path
        d="M32.0002 26.6663C33.4729 26.6663 34.6668 25.4724 34.6668 23.9997C34.6668 22.5269 33.4729 21.333 32.0002 21.333C30.5274 21.333 29.3335 22.5269 29.3335 23.9997C29.3335 25.4724 30.5274 26.6663 32.0002 26.6663Z"
        fill="#18193F"
      />
      <path
        d="M44.0002 26.6663C45.4729 26.6663 46.6668 25.4724 46.6668 23.9997C46.6668 22.5269 45.4729 21.333 44.0002 21.333C42.5274 21.333 41.3335 22.5269 41.3335 23.9997C41.3335 25.4724 42.5274 26.6663 44.0002 26.6663Z"
        fill="#18193F"
      />
      <path
        d="M38.5335 53.3331C36.6668 54.5331 34.4002 55.1997 32.0002 55.1997C25.0668 55.1997 19.3335 49.5997 19.3335 42.5331C19.3335 40.5331 19.7335 38.7997 20.5335 37.0664"
        stroke="#18193F"
        strokeWidth={4}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M26.7998 31.0667C28.3998 30.2667 30.1331 29.8667 31.9998 29.8667C38.9331 29.8667 44.6665 35.4667 44.6665 42.5334C44.6665 43.6 44.5331 44.5334 44.2665 45.4667"
        stroke="#18193F"
        strokeWidth={4}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M28.1333 42.5331L31.2 45.5997L37.6 39.0664"
        stroke="#18193F"
        strokeWidth={4}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
});
